'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = (0, _createReactClass2.default)({
  displayName: 'Button',
  render: function render() {
    return _react2.default.createElement(
      'button',
      { onClick: this.props.whenClicked, className: "btn " + this.props.className, type: 'button' },
      this.props.title,
      _react2.default.createElement(
        'span',
        { className: this.props.subTitleClassName },
        this.props.subTitle
      )
    );
  }
});
exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Button.jsx
// module id = 500
// module chunks = 0